module.exports = __webpack_public_path__ + "img/logo-olonn.9efa98ab.png";